// src/lib/kinema/core/effects/InterpolatorRegistry.ts
import type { Interpolator } from '../types';

export class InterpolatorRegistry {
  private interpolators = new Map<string, Interpolator>();

  register(name: string, interpolator: Interpolator): void {
    this.interpolators.set(name, interpolator);
  }

  getAll(): Map<string, Interpolator> {
    return this.interpolators;
  }

  findForProperty(property: string): Interpolator | undefined {
    for (const interp of this.interpolators.values()) {
      if (interp.properties.includes(property)) return interp;
    }
    return undefined;
  }
}
